document.addEventListener('DOMContentLoaded', function () {

  /* ── SPLASH cycling ── */
  var splashSurface = document.getElementById('splashSurface');
  if (splashSurface) {
    var raw = splashSurface.dataset.imgs || '[]';
    var srcs = [];
    try { srcs = JSON.parse(raw); } catch(e) {}
    if (srcs.length) {
      var si = 0;
      splashSurface.style.backgroundImage = "url('" + srcs[0] + "')";
      setInterval(function () {
        si = (si + 1) % srcs.length;
        splashSurface.style.backgroundImage = "url('" + srcs[si] + "')";
      }, 900);
    }
  }

  window.vxEnter = function () {
    var s = document.getElementById('splash');
    if (s) { s.classList.add('gone'); setTimeout(function(){ s.remove(); }, 900); }
  };

  /* ── HERO cycling ── */
  window._heroIdx = 0;
  var heroImg = document.getElementById('heroImg');
  var heroTag = document.getElementById('heroTag');
  if (heroImg) {
    var hProds = [];
    try { hProds = JSON.parse(heroImg.dataset.products); } catch(e) {}
    window.vxHero = function (i) {
      window._heroIdx = i;
      heroImg.src = hProds[i].src;
      if (heroTag) heroTag.textContent = hProds[i].tag;
      document.querySelectorAll('.hdot').forEach(function(d,j){ d.classList.toggle('on', i===j); });
    };
    if (hProds.length > 1) {
      setInterval(function(){ window.vxHero((window._heroIdx + 1) % hProds.length); }, 3200);
    }
    heroImg.addEventListener('click', function(){
      if (hProds[window._heroIdx]) location.href = hProds[window._heroIdx].url;
    });
  }

  /* ── FACTORY output cycling ── */
  var fImg = document.getElementById('factoryImg');
  var fBadge = document.getElementById('factoryBadge');
  if (fImg) {
    var fImgs = [], fNames = [];
    try { fImgs = JSON.parse(fImg.dataset.imgs); } catch(e) {}
    try { fNames = JSON.parse(fImg.dataset.names); } catch(e) {}
    var fi = 0;
    if (fImgs.length > 1) {
      setInterval(function(){
        fi = (fi + 1) % fImgs.length;
        fImg.src = fImgs[fi];
        if (fBadge) fBadge.textContent = fNames[fi] || 'VERXPAD READY ✦';
      }, 4000);
    }
  }

  /* ── QUICK VIEW ── */
  var qvOv = document.getElementById('qvOv');
  window.vxOpenQv = function (el) {
    if (!qvOv) return;
    document.getElementById('qvImg').src = el.dataset.img || '';
    document.getElementById('qvName').textContent = el.dataset.title || '';
    document.getElementById('qvDesc').textContent = el.dataset.desc || '';
    document.getElementById('qvPrice').textContent = el.dataset.price || '';
    var rt = document.getElementById('qvRtag');
    var rarity = el.dataset.rarity || 'Core';
    var rslug = el.dataset.rslug || 'core';
    rt.textContent = rarity;
    rt.className = 'qv-rtag ccard-rtag--' + rslug;
    var btn = document.getElementById('qvBtn');
    if (btn) btn.href = el.dataset.url || '#';
    qvOv.classList.add('open');
    document.body.style.overflow = 'hidden';
  };
  window.vxCloseQv = function (e) {
    if (e && e.target !== qvOv) return;
    if (qvOv) qvOv.classList.remove('open');
    document.body.style.overflow = '';
  };
  document.addEventListener('keydown', function(e){ if(e.key==='Escape'){ if(qvOv) qvOv.classList.remove('open'); document.body.style.overflow=''; }});

  /* ── ADD TO CART via Shopify AJAX ── */
  window.vxAddCart = function (e, variantId, title) {
    e && e.stopPropagation();
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(r){ return r.json(); })
    .then(function(){
      vxToast(title + ' — ADDED ✓');
      vxUpdateCart();
    })
    .catch(function(){ vxToast('Oops — try again'); });
  };

  function vxUpdateCart() {
    fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(c){
        var el = document.getElementById('navCart');
        if (el) el.textContent = '🛍 Cart (' + c.item_count + ')';
      });
  }

  /* ── PRODUCT FORM (product page) ── */
  var pForm = document.getElementById('pform');
  if (pForm) {
    pForm.addEventListener('submit', function(e){
      e.preventDefault();
      var vid = pForm.querySelector('[name="id"]').value;
      var title = document.querySelector('.p-title') ? document.querySelector('.p-title').textContent : 'Pad';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: vid, quantity: 1 })
      })
      .then(function(r){ return r.json(); })
      .then(function(item){
        vxToast(item.title + ' — ADDED ✓');
        vxUpdateCart();
      });
    });
  }

  /* ── PRODUCT PAGE thumbs ── */
  window.vxThumb = function (el) {
    var main = document.getElementById('pMainImg');
    if (main) main.src = el.dataset.full || el.src;
    document.querySelectorAll('.pthumb').forEach(function(t){ t.classList.remove('on'); });
    el.classList.add('on');
  };

  /* ── TOAST ── */
  window.vxToast = function (msg) {
    var t = document.getElementById('vx-toast');
    if (!t) return;
    t.textContent = msg;
    t.style.transform = 'translateY(0)';
    t.style.opacity = '1';
    setTimeout(function(){
      t.style.transform = 'translateY(120px)';
      t.style.opacity = '0';
    }, 2600);
  };

  /* ── RIPPLE ── */
  document.addEventListener('click', function(e){
    if (e.target.closest('button') || e.target.closest('a')) return;
    var d = document.createElement('div');
    d.className = 'ripple';
    d.style.left = e.clientX + 'px';
    d.style.top = e.clientY + 'px';
    document.body.appendChild(d);
    setTimeout(function(){ d.remove(); }, 700);
  });

  /* ── NAV scroll effect ── */
  var nav = document.getElementById('vxNav');
  if (nav) {
    window.addEventListener('scroll', function(){
      nav.style.boxShadow = window.scrollY > 20 ? '0 4px 40px rgba(0,0,0,.5)' : 'none';
    });
  }
});
